// extracted by css-extract-rspack-plugin
export default {"DateRangeStringsEditor":"src-wab-client-components-sidebar-tabs-ComponentProps-DateRangeStringsEditor-module__DateRangeStringsEditor-dclDG1","dateRangeStringsEditor":"src-wab-client-components-sidebar-tabs-ComponentProps-DateRangeStringsEditor-module__DateRangeStringsEditor-dclDG1"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"DateRangeStringsEditor\":\"src-wab-client-components-sidebar-tabs-ComponentProps-DateRangeStringsEditor-module__DateRangeStringsEditor-dclDG1\",\"dateRangeStringsEditor\":\"src-wab-client-components-sidebar-tabs-ComponentProps-DateRangeStringsEditor-module__DateRangeStringsEditor-dclDG1\"}";
        // 1793541995879
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  